import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie';
import logo from '../images/logo.png'
import Switch from "react-switch";
import googleBtn from "../images/googleBtn.png";
import { useGoogleLogin } from "@react-oauth/google";
import { useAuth } from "../context/AuthContext";

function Login(props) {
    const { accessToken, setAccessToken } = useAuth(); // Google Auth Context
    const [username, setUsername] = useState(localStorage.getItem('username'))
    const [password, setPassword] = useState('')
    const [remmember, setRemmember] = useState(false)

    const apiURL = process.env.REACT_APP_PUBLIC_API_URL;

    useEffect(()=>{
        if(Cookies.get('username')){
            setRemmember(true)
            setUsername(Cookies.get('username'))
        }
        if(localStorage.getItem('remmember') == 'true'){
            setRemmember(true)
        } else {
            setRemmember(false)
        }
    },[])

    async function checkUser(){
        const data = {username, password};
        const jsonString = JSON.stringify(data);
        await fetch( apiURL + '/checkUser.php?data=' + jsonString)
        .then(response => response.json())
        .then(response => {
            if(response.status == 200){
                Cookies.set('access', true, { expires: 480 / 1440 });
                if(remmember){
                    Cookies.set('username', username)
                } else {
                    Cookies.remove('username')
                }
                window.location.reload()
            } else {
                alert("USER NOT FOUND :(")
                setPassword('')
            }
            console.log(response);
        })

        storeSwitch()
    }

    function storeSwitch(){
        if(remmember){
            localStorage.setItem('remmember', true)
            localStorage.setItem('username', username)
        } else {
            localStorage.setItem('remmember', false)
            localStorage.setItem('username', '')
        }
    }

    useEffect(()=>{
        console.log("Remmember: " + remmember);
    },[remmember])

    const login = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
          console.log("✅ Login Success! Token:", tokenResponse.access_token);
          
          // Fetch user profile information
          const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` }
          });
          const userInfo = await userInfoResponse.json();
          
          setAccessToken(tokenResponse.access_token); // Store in context
          Cookies.set('access', true, { expires: 1 }); // 1 day
          Cookies.set('username', userInfo.email, { expires: 1 });
          Cookies.set('google_email', userInfo.email, { expires: 1 });
          Cookies.set('google_photo', userInfo.picture, { expires: 1 });
          Cookies.set('google_name', userInfo.name, { expires: 1 });
          Cookies.set('google_access_token', tokenResponse.access_token, { expires: 1 });
          window.location.reload();
        },
        onError: (error) => console.log("❌ Login Failed:", error),
        scope: "https://www.googleapis.com/auth/drive.file email profile",
        flow: "implicit",
    });

  return (
    <div className='w-full h-full min-h-screen flex items-center justify-center bg-darkGray'>
        <div className='border border-gray-600 px-[70px] py-[60px] rounded-lg flex flex-col items-center justify-center gap-[30px] w-[450px] max-w-[90%]'>
            <img src={logo} className='w-[150px] filter invert' alt='TTF logo'/>
            <div className='text-center text-gray-300 max-w-[80%]'>
                <h2 className='text-2xl font-bold mb-3'>Welcome to TTF Scaffolding</h2>
                <p className='text-gray-400'>Sign in to access the dashboard</p>
            </div>

            <form
                className='w-full flex flex-col gap-3'
                onSubmit={(e)=>{ e.preventDefault(); checkUser(); }}
            >
                <input
                    type='email'
                    placeholder='Username'
                    value={username || ''}
                    onChange={(e)=>setUsername(e.target.value)}
                    className='w-full px-4 py-2 rounded-md bg-darkGray border border-gray-600 text-gray-200 focus:outline-none focus:border-gray-400'
                />
                <input
                    type='password'
                    placeholder='Password'
                    value={password}
                    onChange={(e)=>setPassword(e.target.value)}
                    className='w-full px-4 py-2 rounded-md bg-darkGray border border-gray-600 text-gray-200 focus:outline-none focus:border-gray-400'
                />
                <div className='flex items-center justify-between text-gray-300 text-sm'>
                    <span>Remember me</span>
                    <Switch onChange={()=>setRemmember(!remmember)} checked={remmember} uncheckedIcon={false} checkedIcon={false} onColor='#65D1B5'/>
                </div>
                <button
                    type='submit'
                    className='w-full py-2 rounded-md bg-[#65D1B5] text-white font-semibold hover:opacity-90'
                >
                    Access
                </button>
            </form>

            <div className='flex items-center w-full gap-3 text-gray-500 text-sm'>
                <div className='flex-1 h-px bg-gray-600'/>
                <span>or</span>
                <div className='flex-1 h-px bg-gray-600'/>
            </div>

            <img src={googleBtn} className='w-[200px] cursor-pointer' onClick={login} alt='Sign in with Google'/>
        </div>
    </div>
  )
}

export default Login